// libs
import React from 'react';

// styles
import { Container, Attribute, AttributeLabel, AttributeValue } from './styles';

interface IAttributeColumnizeWidget {
  widget: {
    widget_type: string;
    attributes: [
      {
        label: string;
        value: string;
      }
    ];
  };
  className?: string;
}

function AttributeColumnizeWidget({ widget, className }: IAttributeColumnizeWidget) {
  return (
    <Container className={className}>
      {widget.attributes &&
        widget.attributes.map((item, id) => (
          <Attribute key={id}>
            <AttributeLabel className="attribute-key">{item.label}</AttributeLabel>
            <AttributeValue className="attribute-value">{item.value}</AttributeValue>
          </Attribute>
        ))}
    </Container>
  );
}

export default AttributeColumnizeWidget;
